export default "__VITE_ASSET__XKiSLbqc__"